export default __webpack_public_path__ + "static/media/Handguards of Ardent Fire.b8d4a640.jpg";